import {
  CONTRACT_PROGRESS_PARTICIPANT_USER_TYPE_LOAD_REQUEST,
  CONTRACT_PROGRESS_PARTICIPANT_USER_TYPE_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import UserProvider from '@app/store/contract-progress/UserProvider';

type ContractProgressParticipantUserTypeState = UserProvider | null;

const initialState: ContractProgressParticipantUserTypeState = null;

export default function reducer(
  state: ContractProgressParticipantUserTypeState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_PARTICIPANT_USER_TYPE_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_PARTICIPANT_USER_TYPE_LOAD_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
